import debounce from "lodash.debounce";
import { useMemo } from "react";

export function useThrottledHandler(handler: () => void, delay?: number) {
  return useMemo(
    () => debounce(handler, delay ?? 300),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );
}
